"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = SnapchatSquare;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function SnapchatSquare(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 100,
    height: 100
  }, props), /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("style", {
    dangerouslySetInnerHTML: {
      __html: ".cls-1{fill:#010101;}"
    }
  })), /*#__PURE__*/_react["default"].createElement("title", null, "Snapchat"), /*#__PURE__*/_react["default"].createElement("g", {
    id: "Social_media",
    "data-name": "Social media"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "snapchat-square"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "outline-3",
    "data-name": "outline"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M81.429,92.5H18.571A11.084,11.084,0,0,1,7.5,81.429V18.571A11.084,11.084,0,0,1,18.571,7.5H81.429A11.084,11.084,0,0,1,92.5,18.571V81.429A11.084,11.084,0,0,1,81.429,92.5Zm-62.858-80A6.079,6.079,0,0,0,12.5,18.571V81.429A6.079,6.079,0,0,0,18.571,87.5H81.429A6.079,6.079,0,0,0,87.5,81.429V18.571A6.079,6.079,0,0,0,81.429,12.5Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    className: "cls-1",
    d: "M50,29A21,21,0,1,0,71,50,21,21,0,0,0,50,29ZM64.353,57.7c-.3.686-1.533,1.186-3.794,1.541a10.6,10.6,0,0,0-.364,1.347.652.652,0,0,1-.686.5h-.017c-.525,0-1.084-.245-2.184-.245A4.447,4.447,0,0,0,54.141,62a6.32,6.32,0,0,1-4.166,1.541A6.459,6.459,0,0,1,45.868,62a4.463,4.463,0,0,0-3.167-1.16,21.6,21.6,0,0,0-2.185.262.673.673,0,0,1-.7-.508,10.522,10.522,0,0,0-.364-1.355c-1.168-.178-3.793-.635-3.853-1.812a.6.6,0,0,1,.5-.626c3.921-.644,5.682-4.666,5.758-4.835,0-.009.009-.017.017-.026a1.262,1.262,0,0,0,.135-1.058c-.287-.669-1.515-.906-2.032-1.118-1.338-.525-1.524-1.135-1.439-1.55a1.449,1.449,0,0,1,1.854-.872,3.2,3.2,0,0,0,1.33.356,1.18,1.18,0,0,0,.558-.119c-.118-2.024-.4-4.911.322-6.528a7.688,7.688,0,0,1,7.122-4.6l.567-.009a7.621,7.621,0,0,1,7.138,4.6c.72,1.617.441,4.5.322,6.529a1.059,1.059,0,0,0,.483.118,3.336,3.336,0,0,0,1.244-.355,1.545,1.545,0,0,1,1.152,0,1.178,1.178,0,0,1,.881,1.007c.008.551-.483,1.025-1.457,1.406-.118.051-.262.093-.415.144-.55.178-1.388.44-1.609.974a1.3,1.3,0,0,0,.136,1.058c.008.009.008.017.017.026.076.169,1.837,4.191,5.758,4.835a.649.649,0,0,1,.415.914Z"
  })))));
}